module.exports = require('onyx-common/isArray')
